import { atom } from 'jotai';

import { ActivitySwing } from '@data';

export const swingsAtom = atom<ActivitySwing[]>([]);
